import type * as React from "react";
import {
  type FieldErrors,
  type FieldValues,
  FormProvider,
  type UseFormReturn,
} from "react-hook-form";
import { FieldGroup } from "@/components/ui/field";
import { cn } from "@/lib/utils";

type Props<T extends FieldValues> = {
  methods: UseFormReturn<T>;
  onSubmit: (values: T) => void | Promise<void>;
  onInvalid?: (errors: FieldErrors<T>) => void;
  className?: string;
  /** className ของ element `<form>` — ใช้เมื่อต้องการ layout แบบ flex/scroll */
  formClassName?: string;
  children: React.ReactNode;
};

export function FormRoot<T extends FieldValues>({
  methods,
  onSubmit,
  onInvalid,
  className,
  formClassName,
  children,
}: Props<T>) {
  return (
    <FormProvider {...methods}>
      <form
        className={formClassName}
        onSubmit={methods.handleSubmit(onSubmit, onInvalid)}
      >
        <FieldGroup className={cn("gap-4", className)}>{children}</FieldGroup>
      </form>
    </FormProvider>
  );
}
